export function ProfileRemove({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 2.25C10.5508 2.25 11.8125 3.51171 11.8125 5.0625C11.8051 6.58386 10.6218 7.80784 9.11328 7.86719H9.1123C9.04581 7.86129 8.98073 7.86287 8.91992 7.86621C7.36148 7.80465 6.1875 6.57541 6.1875 5.0625C6.1875 3.51171 7.44921 2.25 9 2.25Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M9.00903 10.3242C10.2728 10.3242 11.4962 10.6458 12.3938 11.2441L12.3977 11.2471C13.1819 11.7638 13.5244 12.4144 13.5295 13.0264C13.5274 13.6427 13.1842 14.2853 12.3918 14.8203C11.4906 15.4254 10.2645 15.75 9.00024 15.75C7.73583 15.75 6.509 15.4255 5.60767 14.8203L5.60571 14.8193L5.46216 14.7188C4.7708 14.2099 4.46997 13.6071 4.46997 13.0352C4.47009 12.4239 4.8142 11.7735 5.61157 11.2461C6.51776 10.6463 7.74551 10.3243 9.00903 10.3242ZM7.63501 11.7676C6.9359 11.7676 6.3676 12.3361 6.36743 13.0352C6.36743 13.7344 6.9358 14.3027 7.63501 14.3027H10.3723C11.0715 14.3027 11.6399 13.7344 11.6399 13.0352C11.6397 12.3361 11.0714 11.7676 10.3723 11.7676H7.63501Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </svg>
    </span>
  );
}
